/* eslint-disable @typescript-eslint/no-unused-vars */
import { ExpandMore, Search } from '@mui/icons-material';
import { Box, Accordion, AccordionSummary, Typography, AccordionDetails, Divider, IconButton } from '@mui/material';
import { IAnomalias } from '../../../services/api/anomaly/AnomalyService';
import { useNavigate, useParams } from 'react-router-dom';
import { formatDateWhitoutHour } from '../../../services/helpers/helpers';
import { estruturaAnomaliasMap } from './FormAnomalia';
import { useCallback, useMemo } from 'react';
import { useAuthContext } from '../../../context';

interface AccordionAnomalyProps {
	data: IAnomalias[];
	historico: boolean;
	risrot?: boolean;
}

export default function AccordionAnomaly({ data, historico, risrot }: AccordionAnomalyProps) {
	const navigate = useNavigate();
	const url = useParams();

	const getItemLabel = (estruturaValue: string, itemValue: string): string => {
		const opcoesAnomalias = estruturaAnomaliasMap[estruturaValue];
		if (opcoesAnomalias) {
			const foundItem = opcoesAnomalias.find(option => option.value === itemValue);
			return foundItem ? foundItem.label : itemValue;
		}
		return itemValue;
	};

	const anomalias = data?.filter(item =>
		item.detalhes?.some(detalhe =>
			detalhe.situacao !== '' && detalhe.situacao !== 'NE' && detalhe.situacao !== 'NI'
		)
	);

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, paddingY: 2, width: '100%' }}>
			{anomalias?.map((itemAnomalia) => (
				<Accordion
					key={itemAnomalia.uuid || itemAnomalia.estrutura + Math.random().toString()}
					square
					sx={{ borderRadius: '30px', '&:before': { display: 'none' } }}
					disableGutters
				>
					<AccordionSummary sx={{ borderRadius: '25px' }} expandIcon={<ExpandMore />}>
						<Typography variant='subtitle1'><strong>Estrutura: </strong><strong>{itemAnomalia.estrutura}</strong></Typography>
					</AccordionSummary>
					<AccordionDetails>
						{/* <Typography variant='body1'><strong>Estrutura:</strong> {itemAnomalia.estrutura}</Typography> */}

						{itemAnomalia.detalhes
							?.filter(detalhe => detalhe.situacao !== '' && detalhe.situacao !== 'NE' && detalhe.situacao !== 'NI')
							.map((detalhe, index) => (
								<Box key={detalhe.uuid || index} sx={{ mb: 3, pt: 2, borderTop: index !== 0 ? '1px solid rgba(0,0,0,0.12)' : 'none' }}>
									<Typography variant='body1'><strong>Item de Inspeção:</strong> {getItemLabel(itemAnomalia.estrutura, detalhe.item)}</Typography>
									<Typography variant='body1'><strong>NPA:</strong> {detalhe.npa}</Typography>
									<Typography variant='body1'><strong>Observações da Inspeção:</strong> {detalhe.observacoes_gerais}</Typography>
									<Typography variant='body1'><strong>Data da Inspeção:</strong> {formatDateWhitoutHour(detalhe.data_inspecao)}</Typography>
									<Typography variant='body1'><strong>Código da anomalia:</strong> {detalhe.codigo_anomalia ?? '---'}</Typography>
									{detalhe.reservatorio_seco && <Typography variant='body1'><strong>Reservatório Seco:</strong> Sim</Typography>}
									{detalhe.vertimento_extravasor && <Typography variant='body1'><strong>Vertimento Extravasor:</strong> Sim</Typography>}
									{detalhe.fluxo_dreno && <Typography variant='body1'><strong>Fluxo Dreno:</strong> Sim</Typography>}

									<Box display='flex' justifyContent='end' width='100%' mt={1}>
										<IconButton
											onClick={() => navigate(`/information_dam/${url.id}/anomaly/${detalhe.uuid}`)}
										>
											<Search />
										</IconButton>
									</Box>
								</Box>
							))}

						{/* <Divider sx={{ my: 1 }} /> */}
						{/* <Typography variant='body1'><strong>Área Responsável:</strong> {itemAnomalia.area_responsavel || 'N/A'}</Typography>
						<Typography variant='body1'><strong>Responsável:</strong> {itemAnomalia.nome_responsavel_procedimento || 'N/A'}</Typography> */}
					</AccordionDetails>
				</Accordion>
			))}
		</Box>
	);
}
